/* eslint-disable import/prefer-default-export */
import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';

export const selectCommonState = createSelector(
  (state: RootState) => state.common,
  (commonState) => commonState
);
